// @flow

import * as actions from "@modules/service/constants/actions";
import * as serviceSettings from "./reducers";
import initialState from "./state";
import type { ServiceSettingsState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: ServiceSettingsState = initialState, action: Object): Object => {
  const act = {
    [actions.GetServiceSettings]: serviceSettings.onServiceSettings,
    [actions.GetServiceSettingsSuccess]: serviceSettings.onServiceSettingsSuccess,
    [actions.GetServiceSettingsError]: serviceSettings.onServiceSettingsError,
    [actions.GetServiceSettingsSchema]: serviceSettings.onGetServiceSettingsSchema,
    [actions.GetServiceSettingsSchemaSuccess]: serviceSettings.onGetServiceSettingsSchemaSuccess,
    [actions.GetServiceSettingsSchemaError]: serviceSettings.onGetServiceSettingsSchemaError,
    [actions.SetEditedServiceSettings]: serviceSettings.onSetEditedServiceSettings,
    [actions.ClearEditedServiceSettings]: serviceSettings.onClearEditedServiceSettings,
    [actions.UpdateServiceSettings]: serviceSettings.onUpdateServiceSettings,
    [actions.UpdateServiceSettingsError]: serviceSettings.onUpdateServiceSettingsError,
    [actions.UpdateServiceSettingsSuccess]: serviceSettings.onUpdateServiceSettingsSuccess,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
